import { newPageInfo } from "@hex-insights/router";
import { hubsPageInfo } from "../pageinfo";

export const holidayHubPageInfo = newPageInfo({
	title: "Holidays",
	description: "Pages related to the Holiday model.",
	exact: false,
	to: hubsPageInfo.to + "/holidays",
	path: hubsPageInfo.path + "/holidays",
	parent: hubsPageInfo,
});
